import {t} from '@lingui/macro';

export const validateRequired = (value: any): boolean | string => {
    if (!value || Array.isArray(value) && !value.length) return t`This field is required.`;
    return true;
}

export const validateQuantity = (value: number, min = 0, max?: number): boolean | string => {
    if (value < min) return t`The value can't be lower than ${min}.`;
    if (max && value > max) return t`The value can't be greater than ${min}.`;
    return true;
};

export const compare = {
    'LT': (a : any, b : any) => a < b,
    'LTE': (a : any, b : any) => a <= b,
    'EQ': (a : any, b : any) => a === b,
    'GT': (a : any, b : any) => a > b,
    'GTE': (a : any, b : any) => a >= b,
};
